import React from "react";
import { useLocation, Navigate } from "react-router-dom";
import { useAuth } from "../hooks";
/**
 * Public route wrap component.
 * Redirects to the redirect page if there is an authenticated user.
 * Use with React Router v6 as a direct child of Route
 *
 * @copyright 2022 Noom, Inc.
 * @author nikola
 */
export function PublicRoute({ redirectPath = "/", children, }) {
    const { isAuthenticated, isLoading, shouldReLogin } = useAuth();
    const location = useLocation();
    if (isAuthenticated && !isLoading && !shouldReLogin()) {
        return React.createElement(Navigate, { to: redirectPath, state: { from: location }, replace: true });
    }
    return React.createElement(React.Fragment, null, children);
}
export default PublicRoute;
//# sourceMappingURL=PublicRoute.js.map